import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const WorkspacesIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Workspaces",
    children: /*#__PURE__*/_jsx("path", {
      d: "M13.714 14.857H2.286a1.146 1.146 0 0 1-1.143-1.143V2.286c0-.629.514-1.143 1.143-1.143h11.428c.629 0 1.143.514 1.143 1.143v11.428c0 .629-.514 1.143-1.143 1.143M3.43 12.571h9.142V3.43H3.43zM29.714 14.857H18.286a1.146 1.146 0 0 1-1.143-1.143V2.286c0-.629.514-1.143 1.143-1.143h11.428c.629 0 1.143.514 1.143 1.143v11.428c0 .629-.514 1.143-1.143 1.143M19.43 12.571h9.143V3.43h-9.143zM13.714 30.857H2.286a1.146 1.146 0 0 1-1.143-1.143V18.286c0-.629.514-1.143 1.143-1.143h11.428c.629 0 1.143.514 1.143 1.143v11.428c0 .629-.514 1.143-1.143 1.143M3.43 28.571h9.142V19.43H3.43zM29.714 30.857H18.286a1.146 1.146 0 0 1-1.143-1.143V18.286c0-.629.514-1.143 1.143-1.143h11.428c.629 0 1.143.514 1.143 1.143v11.428c0 .629-.514 1.143-1.143 1.143M19.43 28.571h9.143V19.43h-9.143z"
    })
  }));
};
WorkspacesIcon.displayName = 'WorkspacesIcon';